<script>
import {
  CurrentSubscriptionElementMixin,
} from "%/dynamic-component-editor/standard-components/current-subscription/current-subscription-element-mixin";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";

export default {
  name: "CurrentSubscriptionLastPaymentDate",
  elementPanelSettings: {
    displayName: "Current Subscription Last Payment Date",
    displayIcon: "calendar",
    elementGroup: "currentSubscriptionElements",
    elementType: "element",
  },
  extends: TextElement,
  mixins: [CurrentSubscriptionElementMixin],
  computed: {
    value() {
      return this.formatSubscriptionDate(this.currentSubscription.date_last_successful_billing);
    },
  },
};
</script>
